import { OptionModel } from "../../common/types/OptionModel";

export const receiptStatus: OptionModel[] = [
    {
        value: "öneri",
        label: "Öneri"
    },
    {
        value: "gerçek",
        label: "Gerçek"
    }
];